import { useState, useEffect, useCallback, useMemo } from "react"
import HeaderSection from "./HeaderSection"
import SummaryTable from "./SummaryTable"
import DetailTable from "./DetailTable"
import { getData, defaultSelected, defaultSelectors, fetchSelectors } from "./helpers"
import "./styles.css"

const GrossMarginTable = () => {
  const [selectors, setSelectors] = useState(defaultSelectors)
  const [selected, setSelected] = useState(defaultSelected)
  const [summaryData, setSummaryData] = useState([])
  const [detailData, setDetailData] = useState([])
  const [csvDownloadTracker, setCsvDownloadTracker] = useState(false)

  // Initial page setup
  useEffect(() => {
    fetchSelectors(setSelectors);
  }, [selected.start, selected.end]);

  // update data when selections are made
  useEffect(() => {
    getData(selected, setSummaryData, setDetailData);
    setCsvDownloadTracker(false);
  }, [selected]);

  const memoizedSetSelected = useCallback(setSelected, []);
  const memoizedSetCsvDownloadTracker = useCallback(setCsvDownloadTracker, []);
  const MemoizedHeaderSection = useMemo(() => (
    <HeaderSection
      selectors={selectors}
      selected={selected}
      setSelected={memoizedSetSelected}
      setCsvDownloadTracker={memoizedSetCsvDownloadTracker}
    />
  ), [selectors, memoizedSetSelected, memoizedSetCsvDownloadTracker]);

  return (
    <div className='gross-margin-container'>
      {MemoizedHeaderSection}
      {selected.customer.length === 0 ? (
        <SummaryTable
          data={summaryData}
          csvDownloadTracker={csvDownloadTracker}
          setSelected={setSelected}
          setCsvDownloadTracker={setCsvDownloadTracker}
          selected={selected}
          setSelectors={setSelectors}
        />
      ) : (
        <DetailTable
          data={detailData}
          csvDownloadTracker={csvDownloadTracker}
          selected={selected}
          setCsvDownloadTracker={setCsvDownloadTracker}
        />
      )}
    </div>
  )
}

export default GrossMarginTable
